import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CTAButton } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { ArrowRight } from "@faire/web--source/slate/icons/Arrow";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackCareersPageViewOpeningsClick } from "@faire/web-api--source/events/careersPage/click/viewOpenings";
import jobOpenings from "@faire/web-api--source/routes/careers/openings";
import * as React from "react";
import styled, { css } from "styled-components";
export var ViewOpeningsButton = function(props) {
    var _props_buttonText;
    return /*#__PURE__*/ _jsx(StyledCTAButton, {
        onClick: function() {
            trackCareersPageViewOpeningsClick();
        },
        linkTo: jobOpenings(),
        variant: props.isSecondary ? "secondary" : "primary",
        $isSecondary: props.isSecondary,
        children: /*#__PURE__*/ _jsxs(SignUpButtonContent, {
            children: [
                (_props_buttonText = props.buttonText) !== null && _props_buttonText !== void 0 ? _props_buttonText : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "GrKqdS",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "View Openings"
                        }
                    ]
                }),
                /*#__PURE__*/ _jsx(StyledArrowRight, {})
            ]
        })
    });
};
export var StyledArrowRight = styled(ArrowRight).withConfig({
    componentId: "sc-3e1ec32a-0"
})([
    "opacity:0;transition:0.5s ease;position:absolute;top:0;bottom:0;margin:auto 0;right:2px;"
]);
export var SignUpButtonContent = styled.span.withConfig({
    componentId: "sc-3e1ec32a-1"
})([
    "transition:0.5s ease;position:relative;padding:0 10px;"
]);
export var StyledCTAButton = styled(CTAButton).withConfig({
    componentId: "sc-3e1ec32a-2"
})([
    "",
    " &:hover{",
    "{padding:0 20px 0 0;}",
    "{opacity:1;right:0;}}"
], function(props) {
    return props.$isSecondary ? css([
        "border:none;"
    ]) : "";
}, SignUpButtonContent, StyledArrowRight);
